// removed by extract-text-webpack-plugin
module.exports = {"popup":"index__popup___3RuE6","popup-box":"index__popup-box___1DHkI","popupBox":"index__popup-box___1DHkI","image":"index__image___13heK","introduction":"index__introduction___3xJUK","title":"index__title___1iU5S","subtitle":"index__subtitle___2CINK","link":"index__link___1xFPW","triangle":"index__triangle___pZNqB","close-button":"index__close-button___3JY3a","closeButton":"index__close-button___3JY3a","popup-close":"index__popup-close___2Tmk_","popupClose":"index__popup-close___2Tmk_","fadeOut":"index__fadeOut___3_wL6","fadeIn":"index__fadeIn___3Ye_j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/Popup/index.css
// module id = 256
// module chunks = 12